import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import InfoIcon from '@material-ui/icons/Info';

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: "2px solid #00567a",
        borderRadius: "8px",
        boxShadow: theme.shadows[5],
        padding: "8px 16px 16px",
        maxHeight: `68vh`,
        width: '75vw',
        overflow: 'auto',
        outline: "none"
    },
}));

const ModalIcon = props => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const createMarkup = props => {
        return { __html: props };
    };

    if (typeof props.float === 'undefined' || props.float === null) {
        props.float = 'unset'
    }

    let _color = props.color;
    if (typeof props.colorOverride !== 'undefined') {
        _color = props.colorOverride;
    }

    const body = (
        <div 
            className={classes.paper} style={{float: props.float}}
        >
            <h3 id="simple-modal-title" className="margin-top-4" style={{color: _color}}>{props.title}</h3>
            <div 
                id="simple-modal-description" 
                style={{fontSize: "1rem"}}
                dangerouslySetInnerHTML={createMarkup(
                    props.body
                )}
            />
            {/* <ModalIcon /> */}
        </div>
    );

    return (
        <div>
            <button type="button" className="button-text" onClick={handleOpen} style={{color: props.color, padding: "0"}}>
                <InfoIcon />
            </button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{
                    display:"flex",
                    flexDirection:"column",
                    justifyContent:"center",
                    alignItems:"center"
                }}
            >
                {body}
            </Modal>
        </div>
    );
    
}

export default ModalIcon;